import React from 'react';
import cn from 'classnames';

import IconSuccess from '@dealroadshow/uikit-icon/IconSuccess';
import baseStyles from '../../tenantInvestorSet.module.scss';
import cardStyles from '@dealroadshow/uikit-styles/card.module.scss';

import styles from './features.module.scss';
import { featuresCollection, featuresDescription, featuresTitle } from './constants';

const featuresCardContent = (feature: string, index: number) => (
  <div
    key={ index }
    className={ styles.feature }
  >
    <div className={ styles.featureIcon }>
      <IconSuccess />
    </div>
    <div className={ styles.featureTitle }>{ feature }</div>
  </div>
);

const Features = () => {
  const featuresCards = featuresCollection.map((featuresCard, index) => (
    <div
      key={ featuresCard.key }
      className={ cn(styles.featuresColumnWrp, {
        [styles.columnWithShadow]: !!(index % 2),
      }) }
    >
      <div className={ styles.featuresColumn }>
        <div className={ styles.featureColumnHeader }>
          <img
            className={ styles.featureColumnIcon }
            src={ featuresCard.icon }
          />
          <span className={ styles.featureColumnTitle }>{ featuresCard.title }</span>
        </div>
        { featuresCard.collection.map(featuresCardContent) }
      </div>
    </div>
  ));

  return (
    <div className={ styles.featuresWrp }>
      <div className={ styles.features }>
        <div className={ baseStyles.mdContainer }>
          <div className={ baseStyles.sectionTitle }>{ featuresTitle }</div>
          <div className={ baseStyles.sectionDescription }>{ featuresDescription }</div>
        </div>
        <div className={ cardStyles.cardContainer }>
          <div className={ styles.featuresRow }>{ featuresCards }</div>
        </div>
      </div>
    </div>
  );
};

export default Features;
